import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CAL_DEMO_BOOKING_URL } from '@app/config';
import { environment } from '@env/environment';
import { TuiButton } from '@taiga-ui/core';
import { RoughNotationModule } from 'ng-rough-notation';

@Component({
  selector: 'app-compare-capgo-hero-section',
  imports: [RoughNotationModule, TuiButton],
  templateUrl: './compare-capgo-hero-section.component.html',
  styleUrl: './compare-capgo-hero-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareCapgoHeroSectionComponent {
  protected readonly bookingUrl = CAL_DEMO_BOOKING_URL;
  protected readonly consoleBaseUrl = environment.consoleBaseUrl;
}
